/**
 * Service API pour les fonctionnalités de plans de formation (Module Tapis)
 */

import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(config => {
  const authHeader = getAuthHeader();
  config.headers = { ...config.headers, ...authHeader };
  return config;
});

// ==================== PLANS DE FORMATION ====================

export const createLearningPath = async (pathData) => {
  const response = await api.post('/learning-paths/create', pathData);
  return response.data;
};

export const listLearningPaths = async (type = 'all', status = 'all') => {
  const response = await api.get('/learning-paths/list', {
    params: { type, status }
  });
  return response.data;
};

// ==================== OBJECTIFS ET ÉCARTS ====================

export const getGapsAnalysis = async (userId) => {
  const response = await api.get(`/learning-paths/gaps/${userId}`);
  return response.data;
};

// ==================== MODULES DE FORMATION ====================

export const getModules = async (source = 'all', category = null) => {
  const params = { source };
  if (category) params.category = category;

  const response = await api.get('/learning-paths/modules', { params });
  return response.data;
};

// ==================== SUIVI DE PROGRESSION ====================

export const getProgress = async (pathId) => {
  const response = await api.get(`/learning-paths/progress/${pathId}`);
  return response.data;
};

// ==================== TABLEAUX DE BORD ====================

export const getDashboard = async () => {
  const response = await api.get('/learning-paths/dashboard');
  return response.data;
};

// ==================== ALERTES ====================

export const getAlerts = async () => {
  const response = await api.get('/learning-paths/alerts');
  return response.data;
};

// ==================== RAPPORTS ====================

export const exportReport = async (format = 'json', pathId = null, startDate = null, endDate = null) => {
  const params = { format };
  if (pathId) params.pathId = pathId;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const response = await api.get('/learning-paths/reports/export', {
    params,
    responseType: format === 'csv' ? 'blob' : 'json'
  });

  if (format === 'csv') {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `learning_paths_report_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  }

  return response.data;
};

// ==================== INTÉGRATION AIGUILLE ====================

export const integrateRecommendations = async (pathId, userId, autoSelect = false) => {
  const response = await api.post('/learning-paths/integrate-recommendations', {
    pathId,
    userId,
    autoSelect
  });
  return response.data;
};

export default {
  createLearningPath,
  listLearningPaths,
  getGapsAnalysis,
  getModules,
  getProgress,
  getDashboard,
  getAlerts,
  exportReport,
  integrateRecommendations
};
